export const invoiceList = {
  head: {
    title: "Fakturowanie",
    subtitle: "Faktury wystawione gościom",
  },
  stats: {
    filterAria: "Filtruj faktury według statusu",
    total: "Razem",
    draft: "Wersje robocze",
    sent: "Wystawione",
    processing: "W trakcie",
    error: "Z błędami",
    pending: "Oczekujące",
    voided: "Anulowane",
  },
  toolbar: {
    searchLabel: "Szukaj faktur",
    searchPlaceholder: "Nr faktury, klient, e-mail, NIP albo rezerwacja…",
    clearSearch: "Wyczyść wyszukiwanie",
    propertyLabel: "Obiekt",
    allProperties: "Wszystkie obiekty",
    typeToSearchProperties: "Proszę pisać, aby wyszukać obiekty.",
    noProperties: "Nie znaleziono obiektów.",
    statusLabel: "Status",
    emisorLabel: "Wystawca",
    allEmisores: "Wszyscy wystawcy",
    servicesTitle: "Katalog wielokrotnego użytku: opłaty i usługi",
    services: "Opłaty i usługi",
    createInvoice: "Utwórz fakturę",
  },
  exportZip: {
    button: "ZIP",
    title: "Jeden plik na fakturę, każdy z datą i kodem rezerwacji, wszystkie w jednym pliku ZIP",
    generating: "Generowanie…",
    zipping: "Kompresowanie…",
    noPdfInPeriod: "W tym okresie nie ma wystawionych faktur z plikiem PDF.",
    noPdfInPage: "Na tej stronie nie ma wystawionych faktur z plikiem PDF.",
    tooMany: "Wybór zawiera {total} faktur, a plik ZIP dopuszcza {limit}. Proszę zawęzić okres albo filtry.",
    noneDownloaded: "Nie udało się pobrać żadnej faktury z Invopop. Proszę spróbować ponownie za kilka minut.",
    failed: "Nie udało się pobrać z Invopop {n} faktur(y): {codes}.",
    withoutPdf: "{n} faktur(y) nie ma jeszcze pliku PDF w Invopop i nie znajdzie się w pliku ZIP: {codes}.",
    restIncluded: "Pozostałe są w pliku ZIP.",
    error: "Nie udało się wygenerować pliku ZIP z fakturami.",
  },
  linkedClient: {
    prefix: "Faktury klienta:",
    fallbackName: "ten klient rozliczeniowy",
    clear: "Usuń filtr klienta",
  },
  table: {
    numberHeader: "NR FAKTURY",
    customerHeader: "KLIENT",
    propertyHeader: "OBIEKT",
    totalHeader: "SUMA",
    statusHeader: "STATUS",
    dateHeader: "DATA",
    actionsHeader: "AKCJE",
    draftReferenceTitle: "Numer roboczy. Numer księgowy jest nadawany przy wystawieniu.",
    openReserva: "Otwórz rezerwację",
    viewCreditNote: "Zobacz korektę {code}",
    creditNote: "Faktura korygująca",
    viewError: "Zobacz błąd",
    voids: "Anuluje",
    correctionOf: "Kor. do",
    correctedBy: "Skorygowana przez:",
  },
  sortFields: {
    number: "numer faktury",
    customer: "klient",
    property: "obiekt",
    total: "suma",
    status: "status",
    date: "data",
  },
  sort: {
    sortBy: "Sortuj według: {label}",
    sortedBy: "Sortowanie: {label}, {direction}. Zmień kolejność",
    asc: "rosnąco",
    desc: "malejąco",
  },
  actions: {
    openPdf: "Otwórz fakturę jako PDF",
    editDraftTitle: "Edytuj dane klienta i pozycje",
    edit: "Edytuj",
    previewTitle: "Otwórz podgląd bez ważności księgowej",
    preview: "Podgląd",
    sendQuote: "Wycena",
    sendQuoteTitle: "Wyślij wycenę e-mailem do klienta",
    emitTitle: "Sprawdź i wystaw fakturę",
    emit: "Wystaw",
    syncTitle: "Odśwież status faktury",
    sync: "Odśwież",
    retryTitle: "Ponów z zaktualizowanymi danymi rozliczeniowymi",
    retry: "Ponów",
    moreOptions: "Więcej opcji",
    moreOptionsAria: "Więcej opcji faktury",
    editCustomer: "Edytuj dane klienta",
    deleteReset: "Usuń i zresetuj zgłoszenie",
    voidReissue: "Anuluj i wystaw ponownie",
  },
  empty: {
    searchTitle: "Nie znaleziono faktur",
    searchText: "Żaden wynik nie pasuje do obecnego wyszukiwania i filtrów.",
    clearFilters: "Wyczyść filtry",
    title: "Brak faktur",
    text: "Można utworzyć wersję roboczą i wystawić ją, gdy dane księgowe i opłaty będą gotowe.",
    createFirst: "Utwórz pierwszą fakturę",
  },
  errorModal: {
    title: "Błąd faktury",
    hintBefore: "Jeśli błąd dotyczy danych rozliczeniowych (NIP, seria…), trzeba je poprawić w",
    hintSettingsPath: "Ustawienia → Fakturowanie",
    hintBetween: "a następnie użyć",
    hintRetryWord: "Ponów",
    hintGuest: "Jeśli błąd dotyczy danych gościa, trzeba użyć",
    hintEditWord: "Edytuj dane klienta",
    close: "Zamknij",
    retryNow: "Ponów teraz",
  },
  editCustomer: {
    title: "Edytuj dane klienta",
    subtitle: "Proszę poprawić dane i ponowić wystawienie faktury",
    name: "Imię i nazwisko / Nazwa firmy *",
    taxId: "NIP / numer VAT",
    country: "Kraj (kod 2-literowy) *",
    email: "E-mail *",
    address: "Adres",
    city: "Miasto",
    zip: "Kod pocztowy",
    hint: "Po zapisaniu wysyłka faktury zostanie ponowiona automatycznie.",
    cancel: "Anuluj",
    saving: "Zapisywanie…",
    save: "Zapisz i ponów",
  },
  deleteConfirm: {
    title: "Usuń fakturę",
    body1: "Ta próba wystawienia faktury zostanie usunięta, a",
    bodyStrong: "zgłoszenie gościa zostanie zresetowane",
    body2: ", dzięki czemu będzie mógł ponownie wpisać dane i poprosić o fakturę.",
    irreversible: "Tej operacji nie da się cofnąć.",
    cancel: "Anuluj",
    deleting: "Usuwanie…",
    confirm: "Tak, usuń",
  },
  create: {
    titleEdit: "Edytuj wersję roboczą",
    titleCreate: "Utwórz fakturę",
    subtitleEdit: "Aktualizacja klienta, kontekstu i pozycji. Faktura nie zostaje wystawiona.",
    subtitleCreate: "Wersja robocza: bez numeru do momentu wystawienia. Rezerwacja nie jest wymagana.",
    loading: "Wczytywanie wersji roboczej…",
    clientLabel: "Klient *",
    clientHelp: "Proszę wybrać zapisany profil rozliczeniowy albo utworzyć nowy.",
    newClient: "Nowy klient",
    company: "Firma",
    individual: "Osoba fizyczna",
    change: "Zmień",
    clientSearchPlaceholder: "Szukaj po nazwie, e-mailu albo dokumencie…",
    incomplete: "Niekompletny",
    noClients: "Nie znaleziono klientów.",
    createClient: "Utwórz klienta",
    contextTitle: "Kontekst faktury",
    optional: "Opcjonalnie",
    contextHelp: "Powiązanie faktury zachowuje jej identyfikowalność. Oba pola można zostawić puste.",
    propertyLabel: "Obiekt",
    propertyPlaceholder: "Szukaj obiektu…",
    typeToSearchProperties: "Proszę pisać, aby wyszukać obiekty.",
    noProperties: "Nie znaleziono obiektów.",
    reservationLabel: "Rezerwacja",
    reservationPlaceholder: "Szukaj kodu, gościa, e-maila…",
    noHolder: "Brak właściciela rezerwacji",
    typeToSearchReservations: "Proszę pisać, aby wyszukać rezerwacje.",
    noReservations: "Nie znaleziono rezerwacji.",
    contextNotice: "Rezerwacja ustala obiekt i dodaje pobyt, jeśli nie został jeszcze zafakturowany.",
    chargesTitle: "Opłaty i usługi",
    chargesHelp: "Proszę wybrać pozycje zapisane w katalogu.",
    addCharge: "Dodaj opłatę albo usługę",
    colConcept: "Pozycja",
    colQty: "Il.",
    colUnitPrice: "Cena jedn.",
    colTotal: "Suma",
    docTitle: "Tak będzie wyglądać faktura",
    docHint: "To są pozycje, które znajdą się w PDF. Nocleg, rabaty i opłaty automatyczne pochodzą z rezerwacji: powyżej edytujesz tylko pozycje z własnego katalogu.",
    due: "Do zapłaty",
    assumed: "Przy tej rezerwacji nie zarejestrowano żadnej wpłaty. Kwota jest uznawana za opłaconą na podstawie wybranej formy płatności i tak samo pojawi się w PDF.",
    linesEmpty: "Proszę dodać co najmniej jedną pozycję z katalogu.",
    total: "Razem",
    cancel: "Anuluj",
    saving: "Zapisywanie…",
    saveChanges: "Zapisz zmiany",
    saveDraft: "Zapisz wersję roboczą",
  },
  contextSummary: {
    property: "Wybrany obiekt",
    empty: "Dodaj obiekt albo rezerwację",
  },
  emit: {
    title: "Wystaw fakturę",
    subtitle: "Ta operacja nada ostateczny numer księgowy.",
    client: "Klient",
    property: "Obiekt",
    total: "Razem",
    warning: "Po wystawieniu nie da się już edytować faktury bezpośrednio; każda poprawka będzie wymagać dokumentu korygującego.",
    cancel: "Anuluj",
    emitting: "Wystawianie…",
    confirm: "Wystaw fakturę",
  },
  editDraft: {
    title: "Edytuj wersję roboczą",
    subtitle: "Zmiana danych klienta i pozycji. Faktura nie zostaje wystawiona.",
    loading: "Wczytywanie wersji roboczej…",
    individual: "Osoba fizyczna",
    individualSub: "Osoba prywatna",
    company: "Firma",
    companySub: "Osoba prawna",
    legalName: "Nazwa firmy *",
    fullName: "Imię i nazwisko *",
    companyNamePlaceholder: "Nazwa firmy",
    individualNamePlaceholder: "Imię i nazwisko",
    country: "Kraj *",
    docCompany: "NIP firmy (VAT)",
    docIndividual: "Dowód / Paszport",
    docCompanyPlaceholder: "VAT / NIP",
    docIndividualPlaceholder: "Dowód osobisty albo paszport",
    email: "E-mail",
    emailOptional: "(opcjonalnie)",
    lodgingTitle: "Zakwaterowanie",
    lodgingName: "Obiekt",
    lodgingNoteBefore: "Pobrane z rezerwacji",
    lodgingNoteAfter: ". Aby zmienić tę kwotę, trzeba edytować ją w rezerwacji.",
    chargesTitle: "Opłaty i usługi",
    chargesHelp: "Dodawanie zapisanych pozycji bez zmiany zakwaterowania.",
    addCharge: "Dodaj opłatę albo usługę",
    colConcept: "Pozycja",
    colQty: "Il.",
    colUnitPrice: "Cena jedn.",
    colTotal: "Suma",
    linesEmpty: "Brak dodatkowych pozycji.",
    linesEmptyReserva: "Faktura obejmuje wyłącznie zakwaterowanie.",
    total: "Razem",
    cancel: "Anuluj",
    saving: "Zapisywanie…",
    saveChanges: "Zapisz zmiany",
  },
  void: {
    doneTitle: "Faktura anulowana",
    doneSubtitle: "Faktura korygująca wystawiona poprawnie",
    whatHappened: "Co się wydarzyło?",
    doneCreditNote: "Wystawiono fakturę korygującą",
    doneListed: "Faktura zostaje na liście oznaczona jako anulowana",
    doneCharges: "Opłaty dodatkowe zostały zwolnione",
    doneGuest: "Gość może ponownie poprosić o swoją fakturę",
    nextStepsLabel: "Kolejne kroki:",
    nextStepsText: "Można dodać albo poprawić opłaty w rezerwacji. Następnie trzeba ponownie wysłać gościowi link do fakturowania.",
    understood: "Rozumiem",
    title: "Anuluj fakturę i wystaw ponownie",
    introBefore: "Ta operacja",
    introStrong: "anuluje wystawioną fakturę",
    introAfter: "za pomocą oficjalnej korekty.",
    willEmit: "Zostanie wystawiona faktura korygująca",
    willList: "Faktura zostanie na liście oznaczona jako anulowana",
    willFree: "Opłaty dodatkowe zostaną zwolnione",
    willAllowGuest: "Gość będzie mógł ponownie poprosić o fakturę",
    reasonLabel: "Powód anulowania",
    reasonOther: "Inny powód…",
    reasonPlaceholder: "Proszę wyjaśnić, dlaczego ta faktura jest anulowana",
    warning: "Korekta jest oficjalnym dokumentem księgowym. Warto jej użyć tylko wtedy, gdy faktura naprawdę wymaga poprawy.",
    cancel: "Anuluj",
    emitting: "Wystawianie korekty…",
    confirm: "Tak, anuluj i wystaw ponownie",
  },
  statusFilters: {
    all: "Wszystkie",
    draft: "Wersje robocze",
    sent: "Wystawione",
    processing: "W trakcie",
    error: "Z błędami",
    pending: "Oczekujące",
    voided: "Anulowane",
  },
  voidReasons: {
    wrongTaxData: "Błędne dane księgowe klienta",
    wrongAmount: "Błędna kwota albo opłaty",
    duplicate: "Faktura zduplikowana",
    cancelledReservation: "Rezerwacja anulowana",
    reissue: "Anulowana w celu ponownego wystawienia z poprawionymi danymi albo opłatami",
  },
  statusLabels: {
    draft: "Wersja robocza",
    sent: "Wystawiona",
    processing: "W trakcie",
    error: "Błąd",
    pending: "Oczekująca",
    corrected: "Skorygowana",
    voided: "Anulowana",
  },
  client: {
    fallbackName: "Klient",
    fiscalPending: "Profil rozliczeniowy do uzupełnienia",
    fiscalSaved: "Profil rozliczeniowy zapisany",
  },
  reservation: {
    noCode: "Brak kodu",
    noDates: "Brak dat",
    noHolder: "Brak właściciela rezerwacji",
    propertyFallback: "Obiekt #{id}",
  },
  emisorFallback: "Wystawca #{id}",
  toasts: {
    selectClientComplete: "Proszę wybrać klienta z kompletnym profilem rozliczeniowym.",
    selectReservationOrCharge: "Proszę wybrać rezerwację albo dodać co najmniej jedną opłatę lub usługę.",
    saveDraftError: "Nie udało się zapisać wersji roboczej.",
    createError: "Nie udało się utworzyć faktury.",
    quoteSent: "Wycena wysłana do {email}",
    quoteError: "Nie udało się wysłać wyceny.",
    previewError: "Nie udało się wygenerować podglądu.",
    previewName: "Podgląd",
    emitRejected: "Platforma księgowa odrzuciła wystawienie.",
    emitError: "Nie udało się wystawić faktury. Proszę sprawdzić dane księgowe i spróbować ponownie.",
    selectClientToContinue: "Aby kontynuować, proszę wybrać klienta z profilem rozliczeniowym.",
    loadDraftError: "Nie udało się wczytać szczegółów wersji roboczej.",
    nameRequired: "Proszę podać nazwę klienta.",
    countryRequired: "Proszę wybrać kraj klienta.",
    selectCatalogCharge: "Proszę wybrać co najmniej jedną opłatę albo usługę z katalogu.",
    retryError: "Ponowna próba nie powiodła się.",
    saveError: "Nie udało się zapisać.",
    voidError: "Nie udało się anulować faktury.",
    deleteError: "Nie udało się usunąć.",
  },
};
